// | ------------------------------------------------------------------------
// | Components - Item Carousel
// | ------------------------------------------------------------------------

//? https://splidejs.com/
import Splide from "@splidejs/splide";

// | ------------------------------------------------------------------------

document.addEventListener("DOMContentLoaded", function () {
  var clientCarousel = document.querySelector(".client-feedback-carousel");
  var orbitHero = document.querySelector(".orbit-hero");

  function DelayedFadeTransition(Splide, Components) {
    const { Elements } = Components;
    const { slides } = Elements;
    let endCallback;

    function mount() {
      // Optional: Set initial opacity
      slides.forEach((slide, index) => {
        slide.style.opacity = index === Splide.index ? '1' : '0';
      });
    }

    function start(index, done) {
      const outgoing = slides.find(slide => slide.classList.contains('is-active'));
      const incoming = slides[index];

      if (outgoing) {
        outgoing.style.zIndex = 1;
        outgoing.style.transition = 'opacity 0.6s ease-out';
        outgoing.style.opacity = '0';
      }

      setTimeout(() => {
        if (incoming) {
          incoming.style.zIndex = 2;
          incoming.style.transition = 'opacity 0.6s ease-in';
          incoming.style.opacity = '1';
        }
        done();
      }, 500);
    }

    function cancel() {
      slides.forEach(slide => {
        slide.style.transition = '';
      });
    }

    return { mount, start, cancel };
  }


  if (clientCarousel) {

    const itemCarousel = new Splide(".client-feedback-carousel", {
      type: "fade",
      rewind: true,
      autoplay: true,
      perPage: 1,
      perMove: 1,
      interval: 6000,
      speed: 2000,
      pagination: false,
      arrows: false,
    });

    itemCarousel.mount({}, DelayedFadeTransition);
    
    clientCarousel.addEventListener("click", (e) => {
      itemCarousel.go("+1");
    });

    if(orbitHero){
      itemCarousel.go( 1 );
    }

  }

});

